import type { CatcherComponent } from './models/CatcherComponent';
import type { MouseEventHandler } from 'react';
import style from './styles/App.module.scss';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

interface CatcherProps {
    release: MouseEventHandler,
    move: MouseEventHandler
}

const Catcher = forwardRef<CatcherComponent, CatcherProps>(({ release, move }, ref) => {
    const [isShowing, setIsShowing] = useState<boolean>(false);
    const theBox = useRef<HTMLDivElement>(null);

    const enable = () => {
        setIsShowing(true);
    };

    const disable = () => {
        setIsShowing(false);
    };

    useImperativeHandle(
        ref,
        () => ({
            enable,
            disable
        }),
        []
    );

    return (<div
        onMouseUp={release}
        onMouseMove={move}
        className={`${ style.catcher } ${ isShowing ? style.on : '' }`}
        ref={theBox}
    />);
});

Catcher.displayName = 'Catcher';

export default Catcher;